import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import Modal from "react-bootstrap/Modal";
import "./../consultaNominas/consultaNominas.scss";
import { memo, useEffect } from "react";
import React, { useState } from "react";
import { handleData } from "../../../../utils/HandleUtils";
import {cambiarNombreUsuario, getBusquedaModUsuarioPasswd} from "../../../services/UsuariosWebService";
import ErrorMessage from "../../../atoms/mensajesError/ErrorMessage";
import Mensaje from "../../../atoms/mensajes/Mensaje";
registerLocale("es", es);

const ModalCambioUsuarioUsuariosWeb = (object = {}) => {
  const [mensaje, setMensaje] = useState("");
  const [showConfirm] = useState(false);
  const [data, setData] = useState({
    usuarioAntiguo: object?.usuario,
    usuarioActual: ""
  })
  const [respuesta,setRespuesta] = useState();
  //const [showError, setShowError] = useState(false);

  const actualizaUsuario = (valores) => {
    setMensaje('');
    
    
    if (valores?.usuarioAntiguo === null && valores?.usuarioAntiguo === "") {
      setMensaje("Debe de indicar el antiguo usuario.");
      
      //setShowError(true);
    } else if (valores?.usuarioActual === null || valores?.usuarioActual === "") {
      setMensaje("Debe de indicar el usuario actual.");
      
      //setShowError(true);
    } else if (valores?.usuarioAntiguo === valores?.usuarioActual) {
      setMensaje("El nuevo usuario debe ser distinto al ya existente.");
      
      //setShowError(true);
    } else {
      // setShowError(false);
      if (object !== null && object !== undefined) {
        
      }
      cambiarNombreUsuario(valores.usuarioActual,object?.niep).then((data) =>{
        
        setRespuesta(data)
        object?.setLoading(true)
        object?.setBusquedaRealizada(false)
        getBusquedaModUsuarioPasswd(valores, object?.currentPage, object?.pageSize).then((data) => {
            
            object?.setListaUsuarios(data)
            object?.setTotalPages(data.totalPages);
            object?.setBusquedaRealizada(true)
            object?.setLoading(false)
        })
      })
    }
    
  };

  useEffect(() => {
    
    setMensaje(mensaje);
  }, [mensaje]);

  function modalCambio() {
    return (
      <Modal
        className={`infModal fechas ${showConfirm ? "opacity-0" : "opacity-100"
          } `}
        show={object.show}
        onHide={object.handleClose}
        backdrop="static"
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <Titulo titulo={"Modificar Nombre de usuario"} tipo={"tituloModal"} /> */}
            <h4 className="tituloModal">Modificar Nombre de usuario</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12 p-3">
            {mensaje!=="" && mensaje!==undefined ? (<>
            {}
            <div className="mb-3">
              <ErrorMessage
                errorMessage={mensaje}
                tiempo={3000}
              />
            </div>
            </>):(<></>)}
            {respuesta !== undefined && respuesta != null ? (<>
            <div className="mb-3">
              <Mensaje
                errorMessage={respuesta}
                tiempo={3000}
              />
            </div>
            </>) : null}
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12">
                <div className="row d-flex justify-content-center mb-2">
                  <div className="col-12 row align-items-center">
                    <label htmlFor="dniAcceso" className="col-4">Antiguo Usuario:</label>
                    <div className="col-8">
                      <input type="text" id="dniAcceso" className="form-control"
                        value={data?.usuarioAntiguo }
                        onChange={(e) => handleData(e.target.value, "usuarioAntiguo", setData)}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-12 row align-items-center mt-3">
                    <label htmlFor="nombreAcceso" className="col-4">Nuevo Usuario:</label>
                    <div className="col-8">
                      <input type="text" id="nombreAcceso" className="form-control"
                        onChange={(e) => handleData(e.target.value, "usuarioActual", setData)}
                      />
                    </div>
                  </div>
                </div>
                <div className="mensajeAviso p-4">
                  <span>AVISO: Recuerde anotar el nuevo usuario para comunicarselo al usuario final.</span>
                </div>
                <div className="row justify-content-center">

                  <div className="col-6">
                    <button
                      className={`btn rounded p-1`}
                      type="button"
                      onClick={() => {
                        actualizaUsuario(data)
                      }}
                    >
                      Cambiar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return <>{modalCambio()}</>;
};

export default memo(ModalCambioUsuarioUsuariosWeb);
